import React from 'react';
import { Link } from 'react-router-dom';

const YELLOW = '#ffcc00';
const BLACK = '#000000';
const WHITE = '#ffffff';

const Footer = () => {
  const quickLinks = [
    { name: 'Startseite', path: '/' },
    { name: 'Unsere Leistungen', path: '/leistungen' },
    { name: 'Kontakt', path: '/kontakt' },
    { name: 'Datenschutz', path: '/datenschutz' }
  ];

  return (
    <>
      {/* Footer */}
      <footer style={{
        backgroundColor: BLACK,
        borderTop: `3px solid ${YELLOW}`,
        color: WHITE
      }}>
        {/* Main Footer Content */}
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '70px 60px',
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr 1.5fr',
          gap: '60px',
          alignItems: 'start'
        }} className="footer-grid">
          
          {/* Column 1 - Logo & Slogan */}
          <div>
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '25px', textDecoration: 'none' }}>
              <div style={{
                width: '55px',
                height: '55px',
                borderRadius: '50%',
                border: `3px solid ${YELLOW}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: BLACK,
                flexShrink: 0
              }}>
                <svg style={{ width: '28px', height: '28px', fill: YELLOW }} viewBox="0 0 24 24">
                  <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
                </svg>
              </div>
              <div>
                <div style={{
                  fontSize: '20px',
                  fontWeight: 900,
                  color: YELLOW,
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  lineHeight: 1.1
                }}>AUTO HOBBY</div>
                <div style={{
                  fontSize: '13px',
                  fontWeight: 600,
                  color: WHITE,
                  letterSpacing: '2.5px',
                  textTransform: 'uppercase',
                  marginTop: '3px'
                }}>WERKSTATT</div>
              </div>
            </Link>
            <p style={{
              fontSize: '15px',
              color: '#aaa',
              lineHeight: 1.8,
              maxWidth: '280px'
            }}>
              Für alle, die selbst anpacken wollen.
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 style={{
              fontSize: '14px',
              fontWeight: 700,
              color: YELLOW,
              marginBottom: '25px',
              textTransform: 'uppercase',
              letterSpacing: '1.5px'
            }}>Schnellzugriff</h3>
            <nav style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              {quickLinks.map((link, i) => (
                <Link
                  key={i}
                  to={link.path}
                  style={{
                    color: '#ccc',
                    textDecoration: 'none',
                    fontSize: '15px',
                    transition: 'color 0.3s ease',
                    fontWeight: 400
                  }}
                  onMouseEnter={(e) => e.target.style.color = YELLOW}
                  onMouseLeave={(e) => e.target.style.color = '#ccc'}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Column 3 - Opening Hours */}
          <div>
            <h3 style={{
              fontSize: '14px',
              fontWeight: 700,
              color: YELLOW,
              marginBottom: '25px',
              textTransform: 'uppercase',
              letterSpacing: '1.5px'
            }}>Öffnungszeiten</h3>
            <div style={{ fontSize: '15px', color: '#ccc', display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <div style={{ color: '#999', fontSize: '13px', marginBottom: '4px' }}>Mo – Su:</div>
                <div style={{ color: WHITE, fontWeight: 500 }}>09:00 – 18:00</div>
              </div>
              
            </div>
          </div>

          {/* Column 4 - Contact Info */}
          <div>
            <h3 style={{
              fontSize: '14px',
              fontWeight: 700,
              color: YELLOW,
              marginBottom: '25px',
              textTransform: 'uppercase',
              letterSpacing: '1.5px'
            }}>Kontakt</h3>
            <div style={{ fontSize: '15px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div>
                <div style={{ color: '#999', fontSize: '11px', marginBottom: '6px', letterSpacing: '1px', textTransform: 'uppercase' }}>Adresse</div>
                <div style={{ color: WHITE, lineHeight: 1.6 }}>
                  Küvenkamp 3<br/>
                  46509 Xanten
                </div>
              </div>
              <div>
                <div style={{ color: '#999', fontSize: '11px', marginBottom: '6px', letterSpacing: '1px', textTransform: 'uppercase' }}>Telefon</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <a href="tel:+4928019856340" style={{
                    color: WHITE,
                    textDecoration: 'none',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = YELLOW}
                  onMouseLeave={(e) => e.target.style.color = WHITE}>
                    +49 2801 9856340
                  </a>
                  <a href="tel:+4915560524486" style={{
                    color: WHITE,
                    textDecoration: 'none',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = YELLOW}
                  onMouseLeave={(e) => e.target.style.color = WHITE}>
                    +49 15560524486
                  </a>
                </div>
              </div>
              <div>
                <div style={{ color: '#999', fontSize: '11px', marginBottom: '6px', letterSpacing: '1px', textTransform: 'uppercase' }}>E-Mail</div>
                <a href="mailto:info@autoshobbywerkstatt.de" style={{
                  color: WHITE,
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = YELLOW}
                onMouseLeave={(e) => e.target.style.color = WHITE}>
                  info@autoshobbywerkstatt.de
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider Line */}
        <div style={{
          height: '1px',
          backgroundColor: YELLOW,
          maxWidth: '1400px',
          margin: '0 auto',
          opacity: 0.25
        }} />

        {/* Bottom Bar - Copyright */}
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '35px 60px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '13px',
          color: '#777'
        }} className="footer-bottom">
          <div style={{ fontWeight: 400 }}>
            © 2025 Auto Hobby Werkstatt – Alle Rechte vorbehalten.
          </div>
        </div>
      </footer>

      <style>{`
        @media (max-width: 968px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr !important;
            gap: 50px !important;
            padding: 60px 40px !important;
          }
          .footer-bottom {
            flex-direction: column !important;
            gap: 20px !important;
            text-align: center;
            padding: 30px 40px !important;
          }
        }
        @media (max-width: 640px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
            gap: 45px !important;
          }
        }
      `}</style>
    </>
  );
};

export default Footer;